<script>
import lang from "@/directives/lang";

export default {
  name: "DictsysInflections",
  directives: {
    lang
  },
  props: {
    inflections: {
      type: Array,
      required: true
    },
    lang: {
      type: String,
      default: "source"
    }
  }
};
</script>

<template>
  <span v-if="inflections.length > 0"
    >&lt;<span v-for="(inflection, inflectionIndex) in inflections" :key="inflectionIndex"
      ><span v-lang:[lang]
        ><span
          v-for="(inflectionVariation, inflectionVariationIndex) in inflection"
          :key="inflectionVariationIndex"
          >{{ inflectionVariation
          }}<i v-if="inflectionVariationIndex < inflection.length - 1"> eller </i></span
        ><span v-if="inflectionIndex < inflections.length - 1">, </span></span
      ></span
    >&gt;</span
  >
</template>
